import { DateTime } from 'luxon'

export const dateInPast = (date: DateTime, compare: DateTime = DateTime.now()) => {
  const compareStart = compare.startOf('day')
  const dayStart = date.startOf('day')

  return dayStart.toSeconds() < compareStart.toSeconds()
}
